<template>
	<v-sheet elevation="0" max-width="700px" class="mx-auto">
		<FunctionTitle :title="''" />
		<CommonFlame :title="title">
			<v-sheet elevation="0" class="mt-4">
				<v-form ref="form">
					<div class="mt-4">
						<label class="text-body-2 font-weight-bold">URL認証</label>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon small class="mr-1" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
							</template>
							<span
								>ログイン時にメールアドレスとパスワードを入力すると、登録メール宛に認証用のURLが送られます。
							</span>
						</v-tooltip>

						<v-radio-group class="mt-1" row v-model="is_confirmation">
							<v-radio
								v-for="(item, index) in confirmableOptions"
								:label="item.name"
								:key="`item-${index}`"
								:value="item.value"
								class="mr-2"
								dense
							/>
						</v-radio-group>
					</div>
					<v-row justify="center" class="my-4">
						<v-btn @click="updateAccount" color="secondary"> アカウントを設定する </v-btn>
					</v-row>
				</v-form>
			</v-sheet>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: { CommonFlame, FunctionTitle },
	data() {
		return {
			title: "アカウント設定",
			is_confirmation: null,
			confirmableOptions: [
				{ name: "設定する", value: true },
				{ name: "設定しない", value: false },
			],
			companyId: this.$store.getters["auth/authData"].company_id,
		}
	},
	mounted() {
		this.fetchAccount()
	},
	methods: {
		fetchAccount() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/account_settings", { headers, params: { company_id: this.companyId } })
				.then((res) => {
					this.is_confirmation = res.data.is_confirmation
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateAccount() {
			const headers = authenticate.setHeader()
			axios
				.put(
					"/erp/v1/account_settings",
					{
						is_confirmation: this.is_confirmation,
						company_id: this.companyId,
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "アカウント情報が更新されました。",
						type: "notice",
					})
					this.$router.push({ name: "erp_settings" })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
